import { AuthContext } from '@/components/contexts/auth.context.tsx'
import { useContext } from 'react'

export function useAuth() {
  const context = useContext(AuthContext)

  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider')
  }

  return context
}
